import React, {useState, useContext, useEffect} from 'react';
import Spinner from '../../Spinner';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponentNotSorted from '../../Selects/SelectComponentNotSorted';
import SelectComponent from '../../Selects/SelectComponent';
import {ToastContainer} from 'react-toastify';
import {useHistory, useParams} from 'react-router-dom';
import {Context} from '../../../Helpers/Auth';
import {toast} from 'react-toastify';
import InputFilter from '../../Filters/InputFilter';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

import {PostDadosContaPesquisa, getReuniaoId, getNegociosId, getVisitas, getEstabelecimentos, getCategoriasReunioes} from '../../../pages/requests';
import {format} from 'date-fns';
import moment from 'moment';
import TablePagination from '../../TablePagination';
import NotFound from '../../NotFound';
import axios from 'axios';

function Agendamentos({negocio, setNovoAgendamento, novoAgendamento, onRowClick}) {
    const FORMATO_DATA = 'YYYY-MM-DD';
    debugger;
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [atividades, setAtividades] = useState([]);
    const history = useHistory();
    const [semDados, setSemDados] = useState(false);

    const [totalProdutos, setTotalProdutos] = useState(0);

    const ITEMS_PER_PAGE = 15;

    const {isCard, openCards} = useContext(Context);

    const [isMobile, setIsMobile] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    // FILTROS

    const [filtroEstab, setFiltroEstab] = useState(null);
    const [filtroCategoria, setFiltroCategoria] = useState(null);
    const [filtroDtInicio, setFiltroDtInicio] = useState({startDate: null, endDate: null});
    const [filtroDtFim, setFiltroDtFim] = useState({startDate: null, endDate: null});
    const [filtroCliente, setFiltroCliente] = useState('');

    // ARRAYS

    const [categorias, setCategorias] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleRowClick = dados => {
        debugger;
        history.push(`Agendamentos?negocio=${negocio.num}&agendamento=${dados.id}`, dados);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

        getVisitas(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,
            signal,
            filtroDtInicio.startDate ?? '',
            filtroDtFim.startDate ?? '',
            filtroCliente,
            negocio.num,
            filtroEstab?.value ?? '',
            [],
            filtroCategoria ? [filtroCategoria.value] : [],
        )
            .then(res => {
                if (res.data.success) {
                    setAtividades(res.data.reunioes);
                    setTotalProdutos(res.data.totalprodutos);
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroDtInicio, filtroDtFim, filtroCategoria, filtroCliente, filtroEstab]);

    function pushNegocio() {
        history.push(`Agendamentos?negocio=${negocio.num}`, negocio);
    }

    /// ??????????????????????
    useEffect(() => {
        if (novoAgendamento) {
            pushNegocio();
            setNovoAgendamento(false);
        }
    }, [novoAgendamento]);

    useEffect(() => {
        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });

        getEstabelecimentos(lang).then(res => {
            setEstabelecimentos(res.data.estabelecimentos);
        });
    }, []);

    function handleChangeFiltro() {
        if ((filtroDtInicio.startDate, filtroDtFim.startDate, filtroCategoria, filtroCliente, filtroEstab)) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros() {
        setFiltroDtInicio({startDate: null, endDate: null});
        setFiltroDtFim({startDate: null, endDate: null});
        setFiltroCategoria(null);
        setFiltroCliente('');
        setFiltroEstab(null);
    }

    useEffect(() => {
        if (atividades.length != 0) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [atividades]);

    return (
        <>
            {atividades.length == 0 && (
                <div>
                    <NotFound frase={t('naoExistemVisitas')} />

                    <div className="flex flex-row justify-center mt-4">
                        <button
                            onClick={() => {
                                pushNegocio();
                            }}
                            // onClick={voltarParaSemanaAtual}
                            className="flex  items-center justify-center font-semibold px-4 h-6 font-sm text-gray-700  rounded-l   dark:text-gray-700  ">
                            <p className="bg-gray-200 hover:bg-blue-400 rounded-[8px] px-1">{t('criarReuniaoVisita')}</p>
                        </button>
                    </div>
                </div>
            )}
            {isMobile || isCard ? (
                <div>
                    {atividades?.map((dados, index) => (
                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row" onClick={() => handleRowClick(dados)}>
                                        {moment(dados.dataI).format(FORMATO_DATA)} | {dados.categoria.label} | {dados.cliente}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('inicio')}:</div> {moment(dados.dataI).format(FORMATO_DATA)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('fim')}: </div> {moment(dados.dataF).format(FORMATO_DATA)}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('categoria')}: </div> {dados.categoria.label}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('estabelecimento')}: </div> {dados.estabelecimento}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div> */}

                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                        <div>
                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                            </span>

                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                        </div>
                        <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                    </nav>
                </div>
            ) : (
                <>
                    {atividades.length != 0 && (
                        <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px] z-0">
                            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">
                                            {t('inicio')}
                                            <Datepicker
                                                displayFormat={FORMATO_DATA}
                                                useRange={false}
                                                asSingle={true}
                                                value={filtroDtInicio}
                                                onChange={newValue => {
                                                    setFiltroDtInicio(newValue);
                                                }}
                                                inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                            />
                                        </th>
                                        <th scope="col" className="px-3 py-3">
                                            {t('fim')}
                                            <Datepicker
                                                displayFormat={FORMATO_DATA}
                                                useRange={false}
                                                asSingle={true}
                                                value={filtroDtFim}
                                                onChange={newValue => {
                                                    setFiltroDtFim(newValue);
                                                    setCurrentPage(1);
                                                }}
                                                inputClassName={`rounded-[8px] w-full bg-gray-50 border border-gray-300 text-xs text-gray-900 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                                            />
                                        </th>
                                        <th scope="col" className="px-3 py-3">
                                            {t('categoria')}
                                            <SelectComponent
                                                options={categorias}
                                                value={filtroCategoria ? filtroCategoria.label : ''}
                                                onChange={e => {
                                                    setFiltroCategoria(e.label);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            {t('cliente')}
                                            <InputFilter
                                                value={filtroCliente}
                                                onSearch={value => {
                                                    setFiltroCliente(value);
                                                    setCurrentPage(1);
                                                }}
                                            />
                                        </th>

                                        <th scope="col" className="px-6 py-3">
                                            {t('estabelecimento')}
                                            <div className="flex flex-row">
                                                <SelectComponent
                                                    options={estabelecimentos}
                                                    value={filtroEstab ? filtroEstab.label : ''}
                                                    onChange={e => {
                                                        setFiltroEstab(e.label);
                                                    }}
                                                    noOptionsMessage={t('semopcoes')}
                                                    placeholder={t('filtro')}
                                                />
                                                {handleChangeFiltro() ? (
                                                    <button
                                                        onClick={limparFiltros}
                                                        type="button"
                                                        className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                        <FilterAltOffIcon />
                                                    </button>
                                                ) : null}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {atividades.map(dados => (
                                        <>
                                            <tr
                                                className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                                onClick={() => handleRowClick(dados)}>
                                                <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                    {moment(dados.dataI).format(FORMATO_DATA)}
                                                </th>
                                                <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                    {moment(dados.dataF).format(FORMATO_DATA)}
                                                </th>
                                                <td className="px-6 py-1">{dados.categoria.label}</td>
                                                <td className="px-6 py-1 text-blue-600 dark:text-blue-500">{dados.cliente}</td>
                                                <td className="px-6 py-1">{dados.estabelecimento}</td>
                                            </tr>
                                        </>
                                    ))}
                                </tbody>
                            </table>
                            {/* <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div> */}
                            {/* {atividades.length === 0 && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )} */}

                            <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                <div>
                                    <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                        {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                        <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalProdutos / ITEMS_PER_PAGE)}</span>
                                    </span>

                                    <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalProdutos}</span>
                                    <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                </div>
                                <TablePagination total={totalProdutos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                            </nav>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

export default Agendamentos;
